import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-stock-counts',
  templateUrl: './stock-counts.component.html',
  styleUrls: ['./stock-counts.component.css']
})
export class StockCountsComponent implements OnInit {
    public setting?: Setting;

    public selectListStockPlaces: StockPlaceItem[] = [];

    public itemsListStockCounts: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(950))[0];
    }

    private async loadStockPlaces() {
        this.selectListStockPlaces = await this.datatask.Post(940);
    }

    private async loadStockCounts() {
        if (!this.setting) return;

        this.itemsListStockCounts = await this.datatask.Post(951, this.setting);
    }

    public onTabChange() {
        this.loadStockCounts();
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'stockplace_id':
                this.loadStockCounts();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadStockPlaces();
        this.loadStockCounts();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    stockplace_id: string;
    show_setting: string;
    bg_stockcount_status: string;
}

interface StockPlaceItem {
    stockplace_id: string;
    stockplace_name: string;
    orderby: number;
}
